import React, { createContext } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
	const { loading, whatsApps, syncProgress, removeSyncProgress } = useWhatsApps();

	return (
		<WhatsAppsContext.Provider value={{ whatsApps, loading, syncProgress, removeSyncProgress }}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
